import * as z from 'zod';
import { appError, err, ok, } from '@orbit-mind/shared-types';
const loginSchema = z.object({
    token: z.string().min(16).optional(),
    user: z.object({ id: z.string().min(1), email: z.email(), displayName: z.string(), firebasePassword: z.boolean().optional() }),
    session: z.object({ expiresAt: z.number() }),
});
export function createPasswordClient(options, client) {
    return async (mode, input) => {
        try {
            const response = await options.fetch(`${options.origin ?? ''}/auth/password/${mode}`, {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'content-type': 'application/json', accept: 'application/json' },
                body: JSON.stringify({
                    ...input,
                    consent: undefined,
                    terms: input.consent?.terms,
                    news: input.consent?.news,
                    client,
                }),
                signal: AbortSignal.timeout(20000),
            });
            const body = await response.json();
            if (!response.ok) {
                const failure = z.object({ code: z.string(), message: z.string(), details: z.unknown().optional() }).safeParse(body);
                const detail = z.object({ reason: z.literal('EMAIL_NOT_VERIFIED') }).safeParse(failure.success ? failure.data.details : undefined);
                return err(appError(failure.success ? failure.data.code : 'INTERNAL', failure.success ? failure.data.message : 'Email sign-in could not be completed.', { retryable: response.status >= 500, ...(detail.success ? { details: detail.data } : {}) }));
            }
            if (mode === 'login') {
                const result = loginSchema.safeParse(body);
                if (!result.success || (client === 'app' && result.data.token === undefined))
                    return err(appError('VALIDATION_FAILED', 'Invalid sign-in response.'));
                return ok({
                    ...(result.data.token === undefined ? {} : { token: result.data.token }),
                    user: result.data.user,
                    expiresAt: result.data.session.expiresAt,
                });
            }
            const result = (mode === 'register' || mode === 'forgot' || mode === 'resend'
                ? z.object({ sent: z.literal(true), delivery: z.literal('link').optional() })
                : z.object({ verified: z.literal(true) })).safeParse(body);
            return result.success
                ? ok('delivery' in result.data && result.data.delivery === 'link' ? { delivery: 'link' } : {})
                : err(appError('VALIDATION_FAILED', 'Invalid sign-in response.'));
        }
        catch {
            return err(appError('NETWORK_UNAVAILABLE', 'Email sign-in could not be reached.', { retryable: true }));
        }
    };
}
//# sourceMappingURL=password.js.map